export class SavedControlPlate{
    constructor(image, text) {
        this.image = image;
        this.text = text;
    }
}